//

module.exports = {
  // baseUrl: "http://10.8.220.113:9000/apis", //测试环境
  baseUrl: "https://intf.tianyugym.cn", //正式环境
  // baseUrl: "http://10.8.117.210:9090/",//吴美琴
  appId:'202168645',//接口appId
  appsecret:'d8f9e912552ca11670c342dd786068fe',//接口appsecret
  wxAppId:'wx59c3abc37368479f',//微信appid 体育
  // wxAppId:'wx67d8303e2c35adfc',//微信appid我们公司

  // 拿token
  // 2h2wpxdwQL2N11bwSgtlDb85lz9AM6xm
  // token: "d871s15g6oq0fzmV6VM2p73Kn5selw0e",//全局sessionStorage中存放用户TOKEN的变量名称 测试token huangwei
  token: '', //用户token
}
